import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { FileService, CacheService, IIdeaBO } from '@mapfre-tech/amap3';
import { map, mergeMap } from 'rxjs/operators';
import { Observable, forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdeaService {

  className = 'IdeaService'

  constructor(private http: HttpClient,private fileService: FileService, private cacheService: CacheService) { }

  getAllIdeas(cache = true, cacheKey = "allIdeas"): Observable<IIdeaBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<IIdeaBO[]>;
    } else {
      const observable = this.http.get<IIdeaBO[]>(environment.base_URL + "/ideas").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getIdeaById(id: number): Observable<IIdeaBO> {
    const params:any = {};
    params.ideaId = id;
    return this.http.get<IIdeaBO[]>(environment.base_URL + "/ideas",{params}).pipe(map((res: IIdeaBO[]) => {return res[0]}));    
  }

  newIdea(label: any) {
    return this.http.post(environment.base_URL + "/ideas", label);
  }

  newIdeaWithFiles(label: any){
     // PRE FILES INI
     const fileNames: any[] = label.fileNames ?? [];
     const filesToUpload = fileNames.filter((f) => f instanceof File);
     label.fileNames = fileNames.filter((f) => !(f instanceof File));
     // PRE FILES END
     //CHECK IF THERE ARE NEW FILES
     if (filesToUpload.length > 0) {
       return this.newIdea(label).pipe(mergeMap((res: any) => {
         const observables = filesToUpload.map((f) => this.fileService.upload(f, 'idea', res));
         return forkJoin(observables).pipe(map(resultFiles => {
           return res;
         }));
       }))
     }
     else {
       return this.newIdea(label)
     }
  }

  updateIdea(id: number, idea: IIdeaBO) {
    return this.http.put(environment.base_URL + `/ideas/${id}`, idea)
  }

  updateIdeaWithFiles(id: number, idea: IIdeaBO){
    // PRE FILES INI
    const fileNames: any[] = idea.fileNames ?? [];
    const filesToUpload = fileNames.filter((f) => f instanceof File);
    idea.fileNames = fileNames.filter((f) => !(f instanceof File));
    // PRE FILES END
    //CHECK IF THERE ARE NEW FILES
    if (filesToUpload.length > 0) {
      return this.updateIdea(id, idea).pipe(mergeMap((res: any) => {
        const observables = filesToUpload.map((f) => this.fileService.upload(f, 'idea', res));
        return forkJoin(observables).pipe(map(resultFiles => {
          return res;
        }));
      }))
    }
    else {
      return this.updateIdea(id, idea)
    }
  }

  deleteIdea(id: number) {
    return this.http.delete(environment.base_URL + `/ideas/${id}`)
  }
}
